import React, { useState, useEffect } from 'react';
import Menu from '../components/menu';
import Footer from '../components/footer';
//import { useAuth } from '../hooks/useAuth';
import PublicPartnerPreview from '../components/partenairesPreview';
import PartenairesConnected from '../components/partenairesAll';
import ImgBannerPartenaire from '../components/imgBannerPartenaire';
import api from '../config/axios';

const Partenaires: React.FC = () => {
  
  const [civilites, setCivilites] = useState([]);
  const [deps, setDeps] = useState([]);
  const [niveau, setNiveau] = useState([]);
  const [loading, setLoading] = useState(true);

    const [isLoggedIn, setIsLoggedIn] = useState(false);
    

  useEffect(() => {
    const token = sessionStorage.getItem('accessToken');
    setIsLoggedIn(!!token);
  }, []);


  useEffect(() => {
    const fetchReferenceData = async () => {
      try {
        // Ces endpoints doivent être publics car nécessaires pour l'affichage
        const [civilitesRes, depsRes, niveauRes] = await Promise.all([
          api.get('/civilite'), 
          api.get('/departement'), 
          api.get('/niveau') 
        ]);

        setCivilites(civilitesRes.data);
        setDeps(depsRes.data);
        setNiveau(niveauRes.data);
      } catch (error) {
        console.error('Error fetching reference data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchReferenceData();
  }, []);

  // Affichage pendant le chargement
  if (loading) {
    return (
      <div>
        <Menu />
        <div className="min-h-screen flex items-center justify-center">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-orange-500 mx-auto mb-4"></div>
            <p className="text-gray-600">Chargement...</p>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="bg-white">
      <Menu />
      
      {/* Bannière Hero Moderne */}
      <div className="relative bg-gradient-to-br from-orange-500 via-orange-600 to-red-600 overflow-hidden">
        {/* Background decoratif */}
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-0 right-0 w-96 h-96 bg-white rounded-full -mr-48 -mt-48"></div>
          <div className="absolute bottom-0 left-0 w-80 h-80 bg-white rounded-full -ml-40 -mb-40"></div>
        </div>

        {/* Contenu */}
        <div className="relative z-10 max-w-6xl mx-auto px-4 py-12 md:py-20">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center">
            {/* Colonne gauche - Texte */}
            <div>
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
                Trouvez votre <span className="text-orange-100">partenaire</span> idéal
              </h1>
              <p className="text-lg md:text-xl text-orange-50 mb-8 leading-relaxed">
                Connectez-vous avec des joueurs de padel passionnés, trouvez des partenaires à votre niveau et participez à des tournois mémorables.
              </p>
              
              {!isLoggedIn && (
                <div className="flex flex-col sm:flex-row gap-4">
                  <a 
                    href="/signup" 
                    className="inline-block bg-white text-orange-600 px-8 py-4 rounded-xl font-bold hover:bg-orange-50 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105 text-center"
                  >
                    S'inscrire maintenant
                  </a>
                  <a 
                    href="/login" 
                    className="inline-block bg-transparent border-2 border-white text-white px-8 py-4 rounded-xl font-bold hover:bg-white hover:text-orange-600 transition-all duration-300 text-center"
                  >
                    Se connecter
                  </a>
                </div>
              )}
            </div>

            {/* Colonne droite - Illustration */}
            <div className="hidden md:block">
              <ImgBannerPartenaire />
            </div>
          </div>
        </div>
      </div>      

      {/* Section Avantages */}
      {!isLoggedIn && (
        <div className="py-16 md:py-20 bg-white">
          <div className="max-w-6xl mx-auto px-4">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Pourquoi rejoindre TournoisPadel ?</h2>
              <p className="text-lg text-gray-600">Découvrez tous les avantages de notre communauté</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {/* Avantage 1 */}
              <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-2xl p-6 hover:shadow-lg transition-shadow">
                <div className="w-12 h-12 bg-blue-500 rounded-full flex items-center justify-center mb-4 mx-auto">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-6 h-6 text-white">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.856-1.487M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 0a3 3 0 11-6 0 3 3 0 016 0zm-6 0a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                </div>
                <h3 className="font-bold text-gray-900 mb-2 text-center">Trouvez des partenaires</h3>
                <p className="text-gray-700 text-sm text-center">Connectez-vous avec des joueurs à votre niveau</p>
              </div>

              {/* Avantage 2 */}
              <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-2xl p-6 hover:shadow-lg transition-shadow">
                <div className="w-12 h-12 bg-green-500 rounded-full flex items-center justify-center mb-4 mx-auto">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-6 h-6 text-white">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                  </svg>
                </div>
                <h3 className="font-bold text-gray-900 mb-2 text-center">Calendrier complet</h3>
                <p className="text-gray-700 text-sm text-center">Accédez à tous les tournois de France</p>
              </div>

              {/* Avantage 3 */}
              <div className="bg-gradient-to-br from-purple-50 to-purple-100 rounded-2xl p-6 hover:shadow-lg transition-shadow">
                <div className="w-12 h-12 bg-purple-500 rounded-full flex items-center justify-center mb-4 mx-auto">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-6 h-6 text-white">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
                  </svg>
                </div>
                <h3 className="font-bold text-gray-900 mb-2 text-center">Notifications</h3>
                <p className="text-gray-700 text-sm text-center">Restez informé des nouveaux matchs</p>
              </div>

              {/* Avantage 4 */}
              <div className="bg-gradient-to-br from-yellow-50 to-yellow-100 rounded-2xl p-6 hover:shadow-lg transition-shadow">
                <div className="w-12 h-12 bg-yellow-500 rounded-full flex items-center justify-center mb-4 mx-auto">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-6 h-6 text-white">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <h3 className="font-bold text-gray-900 mb-2 text-center">Gratuit & Premium</h3>
                <p className="text-gray-700 text-sm text-center">Accès gratuit avec options premium</p>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Contenu principal */}
      <div className={isLoggedIn ? "" : "bg-gray-50 py-12 md:py-16"}>
        {isLoggedIn ? (
          <div className="w-full px-4">
            <PartenairesConnected          
            />
          </div>
        ) : (
          <div className="max-w-7xl mx-auto px-4">
            <PublicPartnerPreview 
              civilites={civilites}
              deps={deps}
              niveau={niveau}
            />
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default Partenaires;